export default __webpack_public_path__ + "static/media/fireDetailsIcon.d9a5d826.svg";